import { computed, nextTick, watch } from 'vue';

export function createDataCenterThemeDrawerOpenState(open, emit, scrollLock) {
  const internalOpen = computed(() => open.value);
  let pendingValue;
  let pendingRequestId = 0;

  function setInternalOpen(nextOpen) {
    const nextValue = Boolean(nextOpen);
    if (nextValue === open.value || pendingValue === nextValue) return;

    const requestId = ++pendingRequestId;
    pendingValue = nextValue;
    emit('update:open', nextValue);

    nextTick(() => {
      if (pendingRequestId === requestId) pendingValue = undefined;
    });
  }

  const stopScrollLockSync = watch(
    open,
    (isOpen) => {
      if (isOpen) scrollLock.acquire();
      else scrollLock.release();
    },
    { flush: 'sync', immediate: true },
  );

  function dispose() {
    pendingRequestId += 1;
    pendingValue = undefined;
    stopScrollLockSync();
    scrollLock.dispose();
  }

  return { internalOpen, setInternalOpen, dispose };
}
